/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export function bValidBirthDay(BirthDay: string) {
    const dateResponse = BirthDay.trim();
    if (dateResponse.length !== 6 && dateResponse.length !== 8) return false;
    
    const day=dateResponse.slice(0,2);
    const month=dateResponse.slice(2,4);
    const year =dateResponse.slice(4,8);
    const date = new Date();

    if (Number(day) > 31 || Number(month) > 12 || Number(year) > date.getFullYear()) {
        return false
    }
    return true;
}